module.exports = __webpack_public_path__ + "static/media/Coffee_at_home_credit_Getty_Images_tablet.ff318cc9.jpg";